var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "surface1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 465.793,
    height: 512,
    viewBox: "0 0 465.793 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M348.945,221.641v-96.9a11.217,11.217,0,0,0-3.093-7.363L237.219,3.309A10.828,10.828,0,0,0,229.43,0H57.2C25.4,0,0,25.93,0,57.73V383.414a57.021,57.021,0,0,0,57.2,57.3H193.148A146.749,146.749,0,0,0,318.852,512c80.886,0,146.941-65.734,146.941-146.727C465.9,294.523,415.105,235.406,348.945,221.641ZM240.1,37.457l72.882,76.723H265.711A25.774,25.774,0,0,1,240.1,88.465ZM57.2,419.375a35.751,35.751,0,0,1-35.852-35.961V57.73c0-20.062,15.9-36.387,35.852-36.387H218.758V88.465a47.045,47.045,0,0,0,46.953,47.058H327.6v83.34c-3.2-.105-5.762-.425-8.536-.425a148.9,148.9,0,0,0-97.32,36.71H86.223a10.67,10.67,0,1,0,0,21.34H201.9a169.784,169.784,0,0,0-18.781,33.082H86.223a10.672,10.672,0,0,0,0,21.344H176.18a143.644,143.644,0,0,0-4.055,34.359c0,19.207,3.734,38.2,10.457,54.211H57.2Zm261.766,71.391A125.387,125.387,0,1,1,444.344,365.379,125.517,125.517,0,0,1,318.961,490.766Zm0,0",
    fill: "#bfbfbf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M86.223,223.027h108.1a10.671,10.671,0,1,0,0-21.343H86.223a10.671,10.671,0,1,0,0,21.343Zm0,0",
    fill: "#bfbfbf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M326.535,286.625a10.592,10.592,0,0,0-15.578,0l-62.535,67.121a10.633,10.633,0,0,0,.535,15.047,10.9,10.9,0,0,0,15.258-.531l44.18-47.274V437.516a10.672,10.672,0,1,0,21.343,0V320.988l43.856,47.274a10.648,10.648,0,0,0,15.582-14.516Zm0,0",
    fill: "#bfbfbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.1eae904391c546431626ad431eb68705.svg";
export { ForwardRef as ReactComponent };